import {
  Background,
  DatesListing,
  FullpageLoading,
  Header,
  HeaderSocialIcon,
  Menu,
  NotPublished,
} from "components/index";
import messages from "i18n/messages";
import first from "lodash/first";
import flowRight from "lodash/flowRight";
import { makeSelectDateByEventId } from "logic/dates";
import {
  fetchEventById,
  makeSelectEventById,
  makeSelectResponseStatus,
} from "logic/events";
import { makeSelectCurOrg } from "logic/orgs";
import { NextSeo } from "next-seo";
import Head from "next/head";
import { sanitizeHTML } from "lib/misc";
import { withRouter } from "next/router";
import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Card, CardBody, Container } from "reactstrap";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";

const basename = process.env.HZL_INST
  ? "https://ticket.theaterimpark.at"
  : "https://shop.ticketteer.com";

class EventIndex extends Component {
  static async getInitialProps(ctx) {
    const { id } = ctx.query;
    const chID = ctx.query["ch-id"];
    ctx.store.dispatch(fetchEventById(id, true));
    return { pageProps: { id, chID } };
  }

  state = {
    mounted: false,
  };

  componentDidMount() {
    // this.props.actions.fetchEventById(this.props.id, true);
    setTimeout(() => this.setState({ mounted: true }), 2000);
  }

  eventImgSrc = (event) =>
    event.images && first(event.images) ? first(event.images).full : null;

  sharingOpts = () => {
    var width = 575,
      height = 400,
      left = (window.innerWidth - width) / 2,
      top = (window.innerHeight - height) / 2;
    return (
      "status=1" +
      ",width=" +
      width +
      ",height=" +
      height +
      ",top=" +
      top +
      ",left=" +
      left
    );
  };

  shareFacebook = () =>
    window.open(
      "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href,
      "facebook-share-dialog",
      this.sharingOpts()
    );

  shareTwitter = () =>
    window.open(
      "https://twitter.com/share",
      "twitter-share-dialog",
      this.sharingOpts()
    );

  render() {
    const {
      status,
      router,
      event,
      org,
      date,
      intl: { formatMessage },
    } = this.props;
    if (status && status === 423)
      return (
        <>
          {this.props.id == "evt_60bdd3bcce2abe00214b650e" ? (
            <script src="https://wait.crowdhandler.com/js/latest/main.js?id=51ad7cc811dbddee06a69b798c26b4870b8a013151ccdf7128c74696c5d775cc"></script>
          ) : null}

          <NotPublished date={date} />
        </>
      );
    if (!event || !org) return <FullpageLoading />;

    return (
      <div>
        <NextSeo
          title={formatMessage(messages.ticketShop, org)}
          description={sanitizeHTML(event.description)}
          canonical={`${basename}${router.asPath}`}
          openGraph={{
            url: `${basename}${router.asPath}`,
            title: event.title,
            description: sanitizeHTML(event.description),
            images: [
              {
                url: this.eventImgSrc(event),
              },
            ],
            site_name: "Ticketteer - Buy Tickets online",
          }}
          twitter={{
            handle: org.social.twitter_user || undefined,
            site: org.social.twitter_user || undefined,
            cardType: "summary_large_image",
          }}
        />
        <Head>
          <meta name="robots" content="index, follow" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          {event.wl && process.env.HZL_INST ? (
            <script src="https://wait.crowdhandler.com/js/latest/main.js?id=51ad7cc811dbddee06a69b798c26b4870b8a013151ccdf7128c74696c5d775cc"></script>
          ) : null}
        </Head>
        <Menu />
        <Background imgSrc={this.eventImgSrc(event)} />

        <Container className="tt-content-wrap">
          <Header
            imgSrc={this.eventImgSrc(event)}
            image={event.images && first(event.images)}
          >
            <div className="tt-header-title">
              <h1 className="text-primary">{event.title}</h1>
              <small>{event.subtitle}</small>
            </div>
            <div className="tt-org-info">
              <div className="small-title">
                <FormattedMessage {...messages.address} />
              </div>
              <p>
                <b>{date.location.name}</b>
                <br />
                {date.location.street}
                <br />
                {date.location.postcode} {date.location.city}
              </p>
              {date.location.web ? (
                <div>
                  <div className="small-title">
                    <FormattedMessage {...messages.web} />
                  </div>
                  <a href={date.location.web}>{date.location.web}</a>
                </div>
              ) : null}
            </div>
            <div className="tt-header-social-icons">
              {org.support_email ? (
                <HeaderSocialIcon
                  icon="tt-icon-email"
                  link={`mailto:${org.support_email}`}
                  tooltip={org.support_email}
                />
              ) : null}
              <HeaderSocialIcon
                icon="tt-icon-logo-fb-simple-2"
                onClick={this.shareFacebook}
                tooltip={formatMessage(messages.shareOnFacebook)}
              />
              <HeaderSocialIcon
                icon="tt-icon-logo-twitter-2"
                onClick={this.shareTwitter}
                tooltip={formatMessage(messages.shareOnTwitter)}
              />
            </div>
          </Header>
          <div className="tt-content with-sidenav">
            <div className="tt-content-inner">
              {!event.wl || this.props.chID || this.state.mounted ? (
                <DatesListing />
              ) : null}
            </div>
          </div>
          {event.description ? (
            <div className="tt-content with-sidenav card info-card mt-4 p-4">
              <div className="tt-content-inner">
                <div className="small-title">
                  <FormattedMessage {...messages.description} />
                </div>
                <div dangerouslySetInnerHTML={{ __html: event.description }} />
              </div>
            </div>
          ) : null}
        </Container>
        {event.event_date_ids && event.event_date_ids.length > 0 ? (
          <Container>
            <Card className="info-card">
              <CardBody>
                <h2 className="text-primary">
                  <FormattedMessage {...messages.venue} />
                </h2>
                <div className="tt-org-info">
                  <div className="small-title">
                    <FormattedMessage {...messages.address} />
                  </div>
                  <p>
                    <b>{date.location.name}</b>
                    <br />
                    {date.location.street}
                    <br />
                    {date.location.postcode} {date.location.city}
                  </p>
                  {date.location.web ? (
                    <>
                      <div className="small-title">
                        <FormattedMessage {...messages.web} />
                      </div>
                      <a href={date.location.web}>{date.location.web}</a>
                    </>
                  ) : null}
                  {date.location.phone ? (
                    <>
                      <div className="small-title">
                        <FormattedMessage {...messages.phone} />
                      </div>
                      <a href={`tel:${date.location.phone}`}>
                        {date.location.phone}
                      </a>
                    </>
                  ) : null}
                </div>
              </CardBody>
            </Card>
          </Container>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
  event: makeSelectEventById((props) => props.id),
  status: makeSelectResponseStatus(),
  date: makeSelectDateByEventId((props) => props.id),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchEventById,
    },
    dispatch
  ),
});

const enhance = flowRight(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(EventIndex);
